/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsCheckCatalogHealth } from "../../funcs/llmModelsCheckCatalogHealth.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CheckModelCatalogHealthRequest$inboundSchema,
};

export const tool$llmModelsCheckCatalogHealth: ToolDefinition<typeof args> = {
  name: "llm-models-check-catalog-health",
  description: `Check a BYO catalog model's health

Probes an available BYO definition whether or not it is active.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsCheckCatalogHealth(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
